<template>
  <v-card outlined rounded="lg" class="pa-4" elevation="0">
    <v-row class="ma-0" v-if="!isResult">
      <v-col class="text-center" cols="12">
        <span>{{ $t('Período') }}</span>
        <div class="d-flex justify-center align-center mt-3">
          <v-menu
            ref="startDateMenu"
            :close-on-content-click="false"
            :return-value.sync="filter.startDate"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                :disabled="isResult"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(filter.startDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="filter.startDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.startDateMenu.save(filter.startDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>

          <span class="mx-2">{{ $t('Até') }}</span>

          <v-menu
            ref="endDateMenu"
            :close-on-content-click="false"
            :return-value.sync="filter.endDate"
            transition="scale-transition"
            @change="list"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                depressed
                append-icon="mdi-calendar"
                class="primary-button"
                style="text-transform: none"
                :disabled="isResult"
                readonly
                v-bind="attrs"
                v-on="on"
              >
                {{ `${formatMonth(endDate)}` }}
              </v-btn>
            </template>
            <v-date-picker
              v-model="endDate"
              type="month"
              locale="pt-br"
              no-title
              scrollable
              @change="
                $refs.endDateMenu.save(endDate),
                  (filterProp.data = null),
                  list()
              "
            >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12">
        <v-divider class="my-4"></v-divider>
      </v-col>
    </v-row>

    <div>
      <v-alert
        type="warning"
        class="my-3 pa-1 text-center"
        v-if="services.length == 0"
      >
        {{ $t('Nenhum serviço encontrado') }}
      </v-alert>

      <div class="wrapper">
        <v-progress-linear
          indeterminate
          color="primary"
          v-if="loading"
          rounded
          class="ma-1"
        ></v-progress-linear>

        <v-simple-table
          v-if="services.length"
          class="main-table"
          height="500"
          fixed-header
        >
          <thead>
            <tr>
              <th class="pa-3 text-center" style="min-width: 140px">
                Responsável
              </th>
              <th
                class="pa-3 text-center"
                style="min-width: 200px; text-transform: capitalize"
                v-for="header in services[0].weeks"
                :key="header.week"
              >
                {{ header.week }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="service in services" :key="service.responsible">
              <td style="min-width: 140px" class="pb-2 text-center">
                <span class="font-weight-bold">{{ service.responsible }}</span>
              </td>
              <td
                class="text-center"
                style="min-width: 200px; font-weight: normal !important"
                v-for="week in service.weeks"
                :key="week.week"
              >
                <p>
                  Solicitadas:
                  <span class="font-weight-bold">{{ week.requested }}</span>
                </p>

                <p>
                  Concluídas:
                  <span class="font-weight-bold">{{ week.completed }}</span>
                </p>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>

      <v-alert
        type="warning"
        class="mt-4 text-center rounded"
        v-if="!loading && services.length === 0"
      >
        {{ $t('Nenhum serviço encontrado') }}
      </v-alert>
    </div>

    <v-row class="ma-0">
      <v-col cols="12" v-if="isResult">
        <strong>{{ $t('Análise crítica') }}</strong>
        <p v-html="review"></p>
      </v-col>
      <v-col cols="12" v-else>
        <tiptap-vuetify
          v-model="filter.review"
          :extensions="extensions"
          :label="$t('Análise crítica')"
          :placeholder="
            $t('Digite sua análise crítica para o indicador abaixo')
          "
          :card-props="{ flat: true, outlined: true, rounded: true }"
          class="primary-input"
          outlined
          dense
          hide-details="auto"
        ></tiptap-vuetify>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../../../services/ApiService'
import moment from 'moment'
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from 'tiptap-vuetify'

export default {
  name: 'ResponsibleServicesByWeek',

  components: {
    TiptapVuetify,
  },

  props: {
    filterProp: Object,
    institution: Object,
    unidades: Array,
    isResult: { type: Boolean, default: false },
    review: String,
  },

  data() {
    return {
      services: [],
      loading: false,
      apiService: new ApiService(),
      page: 1,
      pageSize: 10,
      headers: [{ text: 'Responsável', value: 'responsible', align: 'center' }],
      headerProps: {
        sortByText: 'Ordenar por',
      },

      chartKey: false,
      startDate: '',
      endDate: '',
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      filter: {},
      showChart: true,
      haveResponse: false,
      googleChartData: [],
      opt: {
        colors: ['#212950', '#C4E8F2'],
        legend: {
          position: 'top',
        },
        hAxis: {
          minValue: 0,
        },
      },
      totalPages: 1,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
      },
      optionsPie: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
              size: 11,
            },
          },
        },
      },
      servicesChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      totalSolicited: [],
      totalConclued: [],
      labels: [],
    }
  },

  watch: {
    filterProp: {
      handler() {
        this.list()
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    this.filter.institutionId = this.institution.id
    this.filter.unidadeIds = this.unidades

    this.filter.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.filter.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    this.startDate = moment()
      .add(-1, 'month')
      .clone()
      .startOf('month')
      .format('YYYY-MM-DD')

    this.endDate = moment()
      .add(-1, 'month')
      .clone()
      .endOf('month')
      .format('YYYY-MM-DD')

    console.log(this.filterProp)

    if (this.filterProp && this.filterProp.startDate) {
      this.filter = this.filterProp
      this.startDate = moment(this.filter.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.endDate = moment(this.filter.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    }

    this.list()
  },

  methods: {
    setDates() {
      this.filter.startDate = moment(this.startDate)
        .clone()
        .startOf('month')
        .format('YYYY-MM-DD')

      this.filter.endDate = moment(this.endDate)
        .clone()
        .endOf('month')
        .format('YYYY-MM-DD')
    },

    setInfos() {
      const model = {
        chart: '1.15 - Ordens de serviço por responsável - Período',
        ...this.filter,
        data: null,
      }
      console.log(model)
      this.$emit('setInfos', model)
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    async list() {
      if (this.filterProp.data) {
        const response = JSON.parse(this.filterProp.data)
        this.services = response.content || []
        this.headers = [
          ...this.headers,
          ...this.services[0].weeks.map((x) => {
            return { text: x.week, value: 'weekvalue', align: 'center' }
          }),
        ]

        return
      }

      this.loading = true

      this.filter.page = this.page
      this.filter.pageSize = this.pageSize

      console.log(this.filter)
      try {
        const response = await this.apiService.post(
          'reports/responsibleServicesByWeek',
          this.filter
        )
        this.services = response.content || []
        this.headers = [
          ...this.headers,
          ...this.services[0].weeks.map((x) => {
            return { text: x.week, value: 'weekvalue', align: 'center' }
          }),
        ]
      } catch (error) {
        console.error('Erro ao buscar dados:', error)
        this.services = []
      } finally {
        this.loading = false
      }
    },
  },

  watch: {
    filter: {
      deep: true,
      handler() {
        this.setInfos()
      },
    },
  },
}
</script>

<style scoped>
.main-table {
  font-size: 14px;
  overflow-x: auto;
}

.wrapper {
  overflow-x: auto;
}
</style>
